import { DefaultRootState } from '@databases/redux';
import { DistributiveOmit } from '@databases/types';
import { DatabaseFieldType, DatabaseValue } from '@databases/types/database';
import { DatabaseFilter, DatabaseFilterType } from '@databases/types/database/view';
import { getStringRepresentation } from '@databases/utils/database/field-types';
import {
  getDatabaseFieldOptional,
  createField,
  createEntry,
} from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';

import type { FilterType } from '../components/FilterTypePicker';

export function updateFilterType(
  filter: DatabaseFilter,
  newFilter: DistributiveOmit<FilterType, 'fieldId'>,
  contentId: string,
  state: DefaultRootState
): DatabaseFilter {
  const oldValue: DatabaseValue =
    filter.type === DatabaseFilterType.EQUALS
      ? filter.value
      : filter.type === DatabaseFilterType.GREATER
      ? filter.value
      : filter.type === DatabaseFilterType.LESS
      ? filter.value
      : filter.type === DatabaseFilterType.CONTAINS
      ? { type: DatabaseFieldType.TEXT, value: filter.value }
      : { type: DatabaseFieldType.TEXT, value: '' };

  const database = selectDatabaseByContentIdRequired(state, {
    contentId,
  });
  const field =
    getDatabaseFieldOptional(
      database,
      'fieldId' in filter ? filter.fieldId : undefined
    ) ?? createField(DatabaseFieldType.TEXT);
  const entry = createEntry(database);

  const newValue: any =
    newFilter.type === DatabaseFilterType.EQUALS
      ? oldValue
      : newFilter.type === DatabaseFilterType.GREATER
      ? oldValue
      : newFilter.type === DatabaseFilterType.LESS
      ? oldValue
      : newFilter.type === DatabaseFilterType.CONTAINS
      ? getStringRepresentation({ database, field, entry, value: oldValue }, state)
      : undefined;

  return {
    ...newFilter,
    fieldId: (filter as any).fieldId,
    value: newValue,
  } as any;
}
